/**
 * Version information for dungeo
 * Auto-generated by build.sh - DO NOT EDIT
 */
export const STORY_VERSION = '1.0.0';
export const BUILD_DATE = '2026-05-12T21:38:50Z';
export const ENGINE_VERSION = '0.9.113';
export const VERSION_INFO = { version: STORY_VERSION, buildDate: BUILD_DATE, engineVersion: ENGINE_VERSION } as const;
